// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectProgram-module__titleStep--Faw5n {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);

}

.SelectProgram-module__btnAllBox--QisgB {
    display: flex;
    justify-content: space-between;
    margin-top: 60px;
}


.SelectProgram-module__cardsBox--NEYUv {
    display: flex;
    gap: 20px;
    justify-content: center;
}

.SelectProgram-module__itemCard--Id23l {
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    background-color: rgb(43 93 235 / 5%);
    position: relative;
}

.SelectProgram-module__titleCard--wfoHS>h4 {
    font-size: 16px;
    font-weight: 500;
    color: var(--color-primary);
}

.SelectProgram-module__selectedCard--MJOfr {
    background: linear-gradient(90deg, #1a55ba 5%, #0054e6 95%);
}

.SelectProgram-module__selectedCard--MJOfr>div>p,
.SelectProgram-module__selectedCard--MJOfr>div>h4,
.SelectProgram-module__selectedCard--MJOfr>div>span,
.SelectProgram-module__selectedCard--MJOfr>.SelectProgram-module__downCard--xmnTK>.SelectProgram-module__premiumCard--RK5Ef>span,
.SelectProgram-module__selectedCard--MJOfr>.SelectProgram-module__downCard--xmnTK>.SelectProgram-module__premiumCard--RK5Ef>p {
    color: white;
}

.SelectProgram-module__selectedCard--MJOfr>.SelectProgram-module__downCard--xmnTK {
    border-top: 1px solid white;
}


.SelectProgram-module__recommendedCard--EPkUm {
    position: absolute;
    background-color: #D37FE8;
    color: white;
    padding: 4px;
    top: 10px;
    left: 20px;
    font-size: 12px;
}

.SelectProgram-module__selectededCard--b8dVc {
    position: absolute;
    background-color: white;
    color: var(--color-primary) !important;
    padding: 4px;
    top: 10px;
    right: 20px;
    font-size: 12px;
}

.SelectProgram-module__sumCard--au0QB,
.SelectProgram-module__franCard--y5Ie0 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.SelectProgram-module__sumCard--au0QB>span,
.SelectProgram-module__sumCard--au0QB>p,
.SelectProgram-module__franCard--y5Ie0>span,
.SelectProgram-module__franCard--y5Ie0>p,
.SelectProgram-module__premiumCard--RK5Ef>p {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    margin: 0;
    color: var(--color-title);
}

.SelectProgram-module__sumCard--au0QB>p,
.SelectProgram-module__franCard--y5Ie0>p,
.SelectProgram-module__premiumCard--RK5Ef>p {
    font-size: 15px;
    font-weight: 300;
    display: flex;
    margin: 0;
    color: var(--color-title);
}

.SelectProgram-module__franCard--y5Ie0>p {
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.SelectProgram-module__franCard--y5Ie0>p>span>svg {
    height: 15px;
    display: flex;
}

.SelectProgram-module__downCard--xmnTK {
    border-top: 1px solid #6f879c38;
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.SelectProgram-module__premiumCard--RK5Ef {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.SelectProgram-module__premiumCard--RK5Ef>span {
    font-size: 20px;
    font-weight: 600;
    color: var(--color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
}

.SelectProgram-module__modalBox--sC0ni {
    padding: 15px;
}

.SelectProgram-module__modalBox--sC0ni>h3 {
    margin-top: 0;
    color: var(--color-title);
}

.SelectProgram-module__premiumModalLine--not8z>p,
.SelectProgram-module__riskModalLine--mA9Vb>p,
.SelectProgram-module__franModalLine--GpxTi>p,
.SelectProgram-module__territoryModal--rHmNq>span {
    font-size: 15px;
    font-weight: 300;
    display: flex;
    margin: 4px;
    color: var(--color-title);
}

.SelectProgram-module__franModalLine--GpxTi>p {
    width: 50%;
}

.SelectProgram-module__premiumModalLine--not8z>span,
.SelectProgram-module__riskModalLine--mA9Vb>span,
.SelectProgram-module__franModalLine--GpxTi>span {
    font-size: 15px;
    font-weight: 600;
    display: flex;
    margin: 4px;
    color: var(--color-title);
    align-items: center;
}

.SelectProgram-module__franModalLine--GpxTi>span {
    width: 30%;
    font-size: 14px;
}

.SelectProgram-module__premiumModalLine--not8z>span>svg,
.SelectProgram-module__riskModalLine--mA9Vb>span>svg {
    height: 14px;
}

.SelectProgram-module__colorPremium--HRbg8 {
    color: var(--color-primary);
}

.SelectProgram-module__premiumModal--ar1vt {
    background-color: rgb(43 93 235 / 5%);
    padding: 10px;
    border-radius: 14px;
}

.SelectProgram-module__premiumModalLine--not8z,
.SelectProgram-module__riskModalLine--mA9Vb,
.SelectProgram-module__franModalLine--GpxTi {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}


.SelectProgram-module__descTitleModal--ki18t,
.SelectProgram-module__franTitleModal--UFTeE,
.SelectProgram-module__territoryTitleModal--rHsBD {
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: var(--color-primary);
}

.SelectProgram-module__riskModalLine--mA9Vb>span {
    display: flex;
}

.SelectProgram-module__selectedTab--jdgKd {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 50px 50px 0;
    border-color: transparent #D37FE8 transparent transparent;
    z-index: 2;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
}

.SelectProgram-module__selectedTab--jdgKd svg {
    position: relative;
    right: -42px;
    top: 6px;
    font-size: 18px;
    color: white;
}


@media (max-width: 950px) {
    .SelectProgram-module__itemContainer--zZ5o8 {
        width: 90%;
        min-height: 300px;
    }

    .SelectProgram-module__itemBox--cCdMK,
    .SelectProgram-module__itemBoxDesc--UvZA9 {
        height: 250px;
        width: 90%;
    }

    .SelectProgram-module__cardsBox--NEYUv {
        flex-direction: column;
        justify-content: center;
        align-items: center;

    }

    .SelectProgram-module__premiumModalLine--not8z,
    .SelectProgram-module__riskModalLine--mA9Vb,
    .SelectProgram-module__franModalLine--GpxTi {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-bottom: 1px solid #6f879c38;
    }

    .SelectProgram-module__franModalLine--GpxTi {
        gap: 0px;
    }

    .SelectProgram-module__franModalLine--GpxTi>p,
    .SelectProgram-module__franModalLine--GpxTi>span {
        width: 100%;
    }

    .SelectProgram-module__premiumModalLine--not8z:last-child,
    .SelectProgram-module__riskModalLine--mA9Vb:last-child,
    .SelectProgram-module__franModalLine--GpxTi:last-child {
        border-bottom: none;
    }
}

@media (max-width: 400px) {
    .SelectProgram-module__itemCard--Id23l {
        width: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/cancer-protection/step-1/ui/SelectProgram.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;;;;;IAKI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sCAAsC;IACtC,YAAY;IACZ,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;;;;IAKI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;;;IAII,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;;AAGA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,yDAAyD;IACzD,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;;AAGA;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;;QAEI,aAAa;QACb,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;IAEvB;;IAEA;;;QAGI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kCAAkC;IACtC;;IAEA;QACI,QAAQ;IACZ;;IAEA;;QAEI,WAAW;IACf;;IAEA;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".titleStep {\r\n    text-align: center;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n\r\n}\r\n\r\n.btnAllBox {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 60px;\r\n}\r\n\r\n\r\n.cardsBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    justify-content: center;\r\n}\r\n\r\n.itemCard {\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    width: 400px;\r\n    background-color: rgb(43 93 235 / 5%);\r\n    position: relative;\r\n}\r\n\r\n.titleCard>h4 {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.selectedCard {\r\n    background: linear-gradient(90deg, #1a55ba 5%, #0054e6 95%);\r\n}\r\n\r\n.selectedCard>div>p,\r\n.selectedCard>div>h4,\r\n.selectedCard>div>span,\r\n.selectedCard>.downCard>.premiumCard>span,\r\n.selectedCard>.downCard>.premiumCard>p {\r\n    color: white;\r\n}\r\n\r\n.selectedCard>.downCard {\r\n    border-top: 1px solid white;\r\n}\r\n\r\n\r\n.recommendedCard {\r\n    position: absolute;\r\n    background-color: #D37FE8;\r\n    color: white;\r\n    padding: 4px;\r\n    top: 10px;\r\n    left: 20px;\r\n    font-size: 12px;\r\n}\r\n\r\n.selectededCard {\r\n    position: absolute;\r\n    background-color: white;\r\n    color: var(--color-primary) !important;\r\n    padding: 4px;\r\n    top: 10px;\r\n    right: 20px;\r\n    font-size: 12px;\r\n}\r\n\r\n.sumCard,\r\n.franCard {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.sumCard>span,\r\n.sumCard>p,\r\n.franCard>span,\r\n.franCard>p,\r\n.premiumCard>p {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    display: flex;\r\n    margin: 0;\r\n    color: var(--color-title);\r\n}\r\n\r\n.sumCard>p,\r\n.franCard>p,\r\n.premiumCard>p {\r\n    font-size: 15px;\r\n    font-weight: 300;\r\n    display: flex;\r\n    margin: 0;\r\n    color: var(--color-title);\r\n}\r\n\r\n.franCard>p {\r\n    display: flex;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.franCard>p>span>svg {\r\n    height: 15px;\r\n    display: flex;\r\n}\r\n\r\n.downCard {\r\n    border-top: 1px solid #6f879c38;\r\n    padding-top: 10px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.premiumCard {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n}\r\n\r\n.premiumCard>span {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: var(--color-primary);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.modalBox {\r\n    padding: 15px;\r\n}\r\n\r\n.modalBox>h3 {\r\n    margin-top: 0;\r\n    color: var(--color-title);\r\n}\r\n\r\n.premiumModalLine>p,\r\n.riskModalLine>p,\r\n.franModalLine>p,\r\n.territoryModal>span {\r\n    font-size: 15px;\r\n    font-weight: 300;\r\n    display: flex;\r\n    margin: 4px;\r\n    color: var(--color-title);\r\n}\r\n\r\n.franModalLine>p {\r\n    width: 50%;\r\n}\r\n\r\n.premiumModalLine>span,\r\n.riskModalLine>span,\r\n.franModalLine>span {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    margin: 4px;\r\n    color: var(--color-title);\r\n    align-items: center;\r\n}\r\n\r\n.franModalLine>span {\r\n    width: 30%;\r\n    font-size: 14px;\r\n}\r\n\r\n.premiumModalLine>span>svg,\r\n.riskModalLine>span>svg {\r\n    height: 14px;\r\n}\r\n\r\n.colorPremium {\r\n    color: var(--color-primary);\r\n}\r\n\r\n.premiumModal {\r\n    background-color: rgb(43 93 235 / 5%);\r\n    padding: 10px;\r\n    border-radius: 14px;\r\n}\r\n\r\n.premiumModalLine,\r\n.riskModalLine,\r\n.franModalLine {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n\r\n.descTitleModal,\r\n.franTitleModal,\r\n.territoryTitleModal {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    text-transform: uppercase;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.riskModalLine>span {\r\n    display: flex;\r\n}\r\n\r\n.selectedTab {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-style: solid;\r\n    border-width: 0 50px 50px 0;\r\n    border-color: transparent #D37FE8 transparent transparent;\r\n    z-index: 2;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.selectedTab svg {\r\n    position: relative;\r\n    right: -42px;\r\n    top: 6px;\r\n    font-size: 18px;\r\n    color: white;\r\n}\r\n\r\n\r\n@media (max-width: 950px) {\r\n    .itemContainer {\r\n        width: 90%;\r\n        min-height: 300px;\r\n    }\r\n\r\n    .itemBox,\r\n    .itemBoxDesc {\r\n        height: 250px;\r\n        width: 90%;\r\n    }\r\n\r\n    .cardsBox {\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n    }\r\n\r\n    .premiumModalLine,\r\n    .riskModalLine,\r\n    .franModalLine {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        border-bottom: 1px solid #6f879c38;\r\n    }\r\n\r\n    .franModalLine {\r\n        gap: 0px;\r\n    }\r\n\r\n    .franModalLine>p,\r\n    .franModalLine>span {\r\n        width: 100%;\r\n    }\r\n\r\n    .premiumModalLine:last-child,\r\n    .riskModalLine:last-child,\r\n    .franModalLine:last-child {\r\n        border-bottom: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n    .itemCard {\r\n        width: 300px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleStep": `SelectProgram-module__titleStep--Faw5n`,
	"btnAllBox": `SelectProgram-module__btnAllBox--QisgB`,
	"cardsBox": `SelectProgram-module__cardsBox--NEYUv`,
	"itemCard": `SelectProgram-module__itemCard--Id23l`,
	"titleCard": `SelectProgram-module__titleCard--wfoHS`,
	"selectedCard": `SelectProgram-module__selectedCard--MJOfr`,
	"downCard": `SelectProgram-module__downCard--xmnTK`,
	"premiumCard": `SelectProgram-module__premiumCard--RK5Ef`,
	"recommendedCard": `SelectProgram-module__recommendedCard--EPkUm`,
	"selectededCard": `SelectProgram-module__selectededCard--b8dVc`,
	"sumCard": `SelectProgram-module__sumCard--au0QB`,
	"franCard": `SelectProgram-module__franCard--y5Ie0`,
	"modalBox": `SelectProgram-module__modalBox--sC0ni`,
	"premiumModalLine": `SelectProgram-module__premiumModalLine--not8z`,
	"riskModalLine": `SelectProgram-module__riskModalLine--mA9Vb`,
	"franModalLine": `SelectProgram-module__franModalLine--GpxTi`,
	"territoryModal": `SelectProgram-module__territoryModal--rHmNq`,
	"colorPremium": `SelectProgram-module__colorPremium--HRbg8`,
	"premiumModal": `SelectProgram-module__premiumModal--ar1vt`,
	"descTitleModal": `SelectProgram-module__descTitleModal--ki18t`,
	"franTitleModal": `SelectProgram-module__franTitleModal--UFTeE`,
	"territoryTitleModal": `SelectProgram-module__territoryTitleModal--rHsBD`,
	"selectedTab": `SelectProgram-module__selectedTab--jdgKd`,
	"itemContainer": `SelectProgram-module__itemContainer--zZ5o8`,
	"itemBox": `SelectProgram-module__itemBox--cCdMK`,
	"itemBoxDesc": `SelectProgram-module__itemBoxDesc--UvZA9`
};
export default ___CSS_LOADER_EXPORT___;
